import React from 'react';

import { Styled } from './styles';

const FeaturesTableHeader: React.FC<{
  tableHeader: string | React.ReactNode;
  style?: React.CSSProperties;
}> = ({ tableHeader, style }) => {
  return (
    <Styled.TableHeader
      size="small"
      sizeWide="medium"
      noMargin
      style={style}
      aria-hidden={
        typeof tableHeader !== 'string' &&
        React.isValidElement<{ 'aria-hidden'?: boolean }>(tableHeader)
          ? tableHeader.props['aria-hidden']
          : false
      }
    >
      {tableHeader}
    </Styled.TableHeader>
  );
};

export type FeaturesTableHeadersProps = {
  data: Array<string> | React.ReactNode[];
};

export const FeaturesTableHeaders: React.FC<FeaturesTableHeadersProps> = ({
  data,
}) => {
  return (
    <>
      {data.map((tableHeader, tableHeaderIndex) => {
        if (typeof tableHeader === 'string' && tableHeader.trim() === '') {
          return null;
        }

        return (
          <FeaturesTableHeader
            key={'table header' + tableHeaderIndex}
            tableHeader={tableHeader}
            style={{ gridColumnStart: 2 + tableHeaderIndex }}
          />
        );
      })}
    </>
  );
};
